import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {BaseStateService} from "../../base-state.service";
import {BaseComponent} from "../../base-component";
import {HelpService} from "../help.service";

@Component({
  selector: 'help-button',
  templateUrl: './help-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpButtonComponent extends BaseComponent implements OnInit {
  @Input() key: string;
  @Input() forceVisible: boolean = false;

  constructor(public stateService: BaseStateService, private helpService: HelpService) {
    super();
  }

  ngOnInit(): void {
  }

  openTopic() {
    this.helpService.openTopic(this.key);
  }
}
